import { api } from '@/api/client';
import { readerPlannedSessionsQueryKey } from '@/lib/readerPlannedSessionsCache';

export function getReaderPlannedSessionsQueryOptions(
  readerIds: string[],
  excludeProjectId: string
) {
  const sorted = [...readerIds].filter(Boolean).sort();
  return {
    queryKey: readerPlannedSessionsQueryKey(sorted, excludeProjectId),
    queryFn: () =>
      api.sessions.list({
        readerIds: sorted,
        excludeProjectId,
      }),
    staleTime: 5_000,
  };
}
